import React, { useEffect, useState } from "react";
import { fadeIn, slideIn, staggerContainer, } from "../utils/motion";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import TruncateText from "../TruncateText";


const PlasticSection = ({lang}) => {


const [show,setShow] = useState(false) 

useEffect(() => {
  setTimeout(() => {
 setShow(true);
}, 500);
  
}, []);


const [touchStart, setTouchStart] = useState(0);
const [touchEnd, setTouchEnd] = useState(0);

function handleTouchStart(e) {
    setTouchStart(e.targetTouches[0].clientX);
}

function handleTouchMove(e) {
    setTouchEnd(e.targetTouches[0].clientX);
}

function handleTouchEnd() {
    if (touchStart - touchEnd > 175) {
        // do your stuff here for left swipe
    setShow(false)
    }

    if (touchStart - touchEnd < -175) {
        // do your stuff here for right swipe
        setShow(true)
    }
}


 
const [width, setWidth] = useState(window.innerWidth);
  
useEffect(() => {
  const handleResize = () => setWidth(window.innerWidth);
  window.addEventListener("resize", handleResize);
//  console.log(window.innerWidth);
  return () => window.removeEventListener("resize", handleResize);
}, []);


const [more, setMore] = useState(false)
const data = useSelector((state) => state.cart.constants); 
  
  return (
    <motion.section
    variants={staggerContainer()}
   initial='hidden'
   whileInView='show'
   viewport={{ amount: 0.25 }}
   onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} 
    dir="rtl" 
    className ={`relative bg-[#F4F4F4] mt-[8px]   w-full `}>
    <span className='hash-span' id={'PlasticSection'}>
   
   </span>
   <motion.div variants={slideIn('left', '', 0.1, 1)} >
<div  className={`relative  h-[270px] xl:h-[700px] lg:h-[600px] md:h-[450px] sm:h-[350px] xs:h-[270px]  w-full`}>


<div dir="rtl" className="flex w-full">



<img  style={{ zIndex:0 }}
    
    src="img/pipe-storage.png"
    alt="al-hubaishi plastic pipes-storage."
    className={`absolute left-[-5%] bottom-[10%] w-[30%] `} />
      


<div style={{zIndex:2}} onClick={()=>setShow(!show)} className="absolute w-full h-[100%]" />

<div   className=" w-[50%] flex flex-col self-stretch my-auto text-[#323131] pt-10 pr-10 p-1 ">
<motion.h2 variants={fadeIn('left','',1,0.7)} style={{fontFamily:'CairoExtraBold'}} className={`${lang === 'en' ? 'text-left' :'text-right'}  text-[20px]  lg:text-[50px]  md:text-[40px]  sm:text-[30px]  xs:text-[20px]  `} >
{  lang=== 'en' ? 'Plastic' :'البلاستيك'} 
                      </motion.h2>
                      <motion.p variants={fadeIn('left','',1,0.7)} style={{height:`${(width/2)/5}px`,overflowY:'auto',whiteSpace:more?'pre-wrap':'',zIndex:3}}  className={`relative ${lang === 'en' ? 'text-left' :'text-right'} text-[8px] xl:text-[20px] lg:text-[16px] md:text-[13px] sm:text-[10px] xs:text-[8px]`} >
                      {    
                  lang=== 'en' ?  
                      
                        
                    data&&data.length ?
                        
                      
                      data&&data[5].value_en?.length > 150 ? 
                          <>
                        {more ? data&&data[5].value_en : TruncateText(data&&data[5].value_en , 150)}
                        <span className='text-blue-500 cursor-pointer' onClick={()=>{setMore(!more)}} >
                        
                        {more ?'Less' : 'More'}
                        
                        </span> 
                        </>
                        :data&&data[5].value_en 
                    
                     :''
    
    
    
                  : 
                    
    
                       data&&data.length ?
                        
                      
                        data&&data[5].value?.length > 150 ? 
                            <>
                          {more ? data&&data[5].value : TruncateText(data&&data[5].value , 150)}
                          <span className='text-blue-500 cursor-pointer' onClick={()=>{setMore(!more)}} >
                          
                      
                          { more ?  'الغاء' : 'المزيد'}
                          </span> 
                          </>
                          :data&&data[5].value 
                      
                       :''
                        }
    
                      </motion.p>                  

                    </div>
</div>


       


<img  style={{ zIndex:0 }}
    
    src="img/Palstic Factory.png"
    alt="al-hubaishi plastic"
    className={`absolute z-1 transition-all  duration-[4s]   ease-in-out left-[10%] bottom-[5%] w-[50%] ${show ? 'translate-x-[110%]' : 'translate-x-[0%] '}  `} />
      






</div>
</motion.div>

    </motion.section>
  );
};

export default PlasticSection;
